import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/event/event_01.jpg")